import { Box, Button, Collapse, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TableCellProps, TextField, Typography, useTheme } from "@mui/material"
import { useEffect, useState } from "react"
import { PartnerService } from "../../../services/partner"
import { LineComponent } from "../../../components/line"
import { Format } from "../../../utils"
import { CiSearch } from "react-icons/ci";
import { copyToClipboard } from "../../../components/copy"
import useAuth from "../../../context/auth"
import { FaCheck, FaRegCopy } from "react-icons/fa6"
import { BiLogoWhatsapp } from "react-icons/bi"
import { TableComponent } from "../../../components/table"
import { MdOndemandVideo } from "react-icons/md"
import { saveAs } from "file-saver"
import InstagramLogo from "../../../assets/img/instagram logo.png"
import { ModalVideoPartner } from "../../../components/video/modal"

export interface IClient {
    id: number
    actualTable: number
    totalPaid: number
    totalLateCharges: number
    status: number
    lastVerification: string
    lastScoreSum: number
    addressFileId: number
    nextVerification: string
    canRequestAfter: string
    welcomeFileId: any
    welcomeLockKey: string
    welcomeLocked: boolean
    fakeTable: any
    welcomeGenerated: boolean
    userData: {
        id: number
        uuid: string
        name: string
        cpf: string
        email: string
        password: string
        role: number
        data: {
            birthday: string
            phone: string
            address: {
                cep: string
                city: string
                district: string
                number: string
                street: string
                uf: string
                complement: string
            }
        }
        status: number
        indicatedBy: any
        redefinePassToken: any
        lastLogin: string
        createdAt: string
    }
    enterprise: {
        document: string
        name: string
        data: {
            qsa: Array<{
                nome: string
                qual: string
            }>
            birthday: string
            socialReason: string
            size: string
            situation: string
            address: {
                street: string
                number: string
                city: string
                district: string
                uf: string
                cep: string
            }
            email: string
            phone: string
            cnae: Array<string>
        }
        userId: number
        createdAt: string
    }
}


export const PartnerClients = () => {
    const [search, setSearch] = useState("")
    const { user, handleModal, isMobile } = useAuth()
    const { palette } = useTheme()

    const [loading, setLoading] = useState(false)
    const [clients, setClients] = useState<IClient[]>([])
    const [copied, setCopied] = useState(false)
    const [openModalVideo, setOpenModalVideo] = useState(false)


    const link = `https://gyroo.com.br/simular?p=${user?.uuid}`

    const getClients = (_search?: string) => {
        setLoading(true)
        PartnerService.getClients(_search)
            .then(({ data }) => {
                setClients(data?.clients)
            })
            .finally(() => setLoading(false))
    }

    const MobileClient = ({ client }: { client: IClient }) => {
        return (
            <Box
                sx={{
                    backgroundColor: "#FFFFFF",
                    borderRadius: "10px",
                    boxSizing: "border-box",
                    p: "1.5rem",
                    width: "100%",
                    cursor: "pointer",
                    border: `1px solid ${palette.primary.light}`,
                    display: "flex",
                    flexDirection: "column",
                    gap: ".5rem"
                }}
            >
                <Typography fontSize={"1.4rem"} fontWeight={700} textAlign={"left"}>{client?.userData?.name}</Typography>
                <LineComponent usedInModal height="1px" margin="1rem 1rem" />

                <Typography fontSize={"1.4rem"} color="#707070" textAlign={"left"}><strong>ID: </strong>{client?.userData?.id}</Typography>
                <Typography fontSize={"1.4rem"} color="#707070" textAlign={"left"}><strong>Data da cadastro: </strong>{Format.date(client?.userData?.createdAt)}</Typography>
                <Typography fontSize={"1.4rem"} color="#707070" textAlign={"left"}><strong>Empresa: </strong>{client?.enterprise?.name}</Typography>
                <Typography fontSize={"1.4rem"} color="#707070" textAlign={"left"}><strong>CNPJ: </strong>{client?.enterprise?.document}</Typography>
                <Typography fontSize={"1.4rem"} color="#707070" textAlign={"left"}><strong>WhatsApp: </strong>{Format.whatsAppNumber(client?.userData?.data?.phone)}</Typography>
                <Typography fontSize={"1.4rem"} color="#707070" textAlign={"left"}><strong>UF: </strong>{client?.userData?.data?.address?.uf}</Typography>
                <Typography fontSize={"1.4rem"} color="#707070" textAlign={"left"}><strong>Cidade: </strong>{client?.userData?.data?.address?.city}</Typography>
            </Box>
        )
    }

    const copy = async () => {
        const success = await copyToClipboard(link)

        if (success) {
            setCopied(true)
            handleModal(true, {
                message:
                    <>
                        <Typography fontWeight={"bold"}>Link copiado com sucesso</Typography>
                        <Typography fontSize={"1.4rem"} mt={"1rem"} fontWeight={400} color="black !important">Envie o link para seus clientes</Typography>
                    </>,
                type: "success"
            })
        } else {
            handleModal(true, {
                message: "Erro ao copiar código",
                type: "error"
            })
        }
    }

    const shareWhatsApp = () => {
        window.open(`https://wa.me/?text=${Format.whatsAppMessage(`Gyroo • Crédito para sua empresa!\n\nClique no link e solicite seu crédito de R$ 1 MIL agora mesmo!\n\n${link}
        `)}`, '_blank')
    }

    const fetchWithRetry = async (
        url: string,
        retries: number = 3,
        delay: number = 1000
    ): Promise<Blob> => {
        for (let i = 0; i < retries; i++) {
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return await response.blob();
            } catch (error: unknown) {
                const errorMessage = error instanceof Error ? error.message : "Erro desconhecido";
                console.error(`Tentativa ${i + 1} falhou: ${errorMessage}`);

                if (i < retries - 1) {
                    await new Promise((res) => setTimeout(res, delay));
                } else {
                    throw error; // Repassa o erro após todas as tentativas
                }
            }
        }

        // Caso todas as tentativas falhem, o TypeScript exige uma garantia de retorno ou throw
        throw new Error("Falha inesperada ao executar fetchWithRetry");
    };

    const downloadFiles = async () => {
        const files = [
            {
                url: "https://s3.us-east-1.amazonaws.com/static.gyroo.com.br/app/video+gyroo.mp4",
                name: "video gyroo.mp4",
            },
        ];

        try {
            // Faz download dos arquivos simultaneamente
            await Promise.all(
                files.map(async (file) => {
                    const blob = await fetchWithRetry(file.url) as Blob;
                    saveAs(blob, file.name);
                })
            );

            console.log("Todos os arquivos foram baixados com sucesso! ✔️");
        } catch (error) {
            console.error("Erro ao baixar os arquivos:", error);
            handleModal(true, {
                type: "error",
                message: "Houve uma falha ao baixar o vídeo."
            })
        }
    };


    const reorderProperties = (array: IClient[]) => {
        return array.map((item) => ({
            id: item?.id,
            createdAt: item?.userData?.createdAt,
            name: item?.userData?.name,
            enterprise: item?.enterprise?.name,
            cnpj: item?.enterprise?.document,
            phone: Format.whatsAppNumber(item?.userData?.data?.phone),
            uf: item?.userData?.data?.address?.uf,
            city: item?.userData?.data?.address?.city
        }))
    }


    useEffect(() => {
        getClients()

        const videoReads = localStorage.getItem('video-partner-reads')
        if (Number(videoReads ?? 0) < 2) {
            setOpenModalVideo(true)
            return
        }
    }, [])

    return (
        <Box
            sx={{
                maxWidth: "150rem",
                margin: "0 auto",
                ...(!isMobile && {
                    padding: "0 2rem"
                })
            }}
        >

            <Typography
                fontSize={"1.6rem"}
                fontWeight={100}
                fontFamily={"Nexa ExtraLight"}
                width={"100%"}
                textAlign={"center"}
                onClick={() => copy()}
                mt={"3rem"}
            >
                Copie o link abaixo para convidar seus clientes e receba <strong>5% de comissão</strong> sobre todos contratos aprovados
            </Typography>
            <Typography
                fontSize={isMobile ? "1.4rem" : "1.6rem"}
                fontWeight={700}
                width={"100%"}
                textAlign={"center"}
                color={"primary"}
                onClick={() => copy()}
                mb={"-3rem"}
                mt={"3rem"}
                p={0}

            >
                ENVIE O LINK PARA CONVIDAR SEUS CLIENTES
            </Typography>

            <Grid
                display={"flex"}
                direction={"row"}
                boxSizing={"border-box"}
                gap={"1rem"}
                maxWidth={isMobile ? "calc(100vw - 5rem)" : "80rem"}
                margin={"3rem auto"}
            >
                <Grid
                    onClick={() => copy()}
                    sx={{
                        height: "4.9rem",
                        width: "calc(100% - 4.9rem - 2rem)",
                        border: "1px solid black",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        overflow: "hidden",
                        pl: ".8rem",
                    }}>
                    <Typography
                        fontSize={"1.4rem"}
                        fontWeight={600}
                        lineHeight={"1.694rem"}
                        width={"100%"}
                        whiteSpace={"nowrap"}
                        overflow={"hidden"}
                        textOverflow={"ellipsis"}
                    >
                        {link}
                    </Typography>
                </Grid>

                <IconButton
                    onClick={() => copy()}
                    sx={{
                        height: "4.9rem",
                        width: "4.9rem",
                        border: "1px solid black",
                        borderRadius: "10px",
                        // animation: "pulse 1.5s infinite"
                    }}
                >
                    {!copied ? <FaRegCopy size={20} color="#000000" /> : <FaCheck size={20} color="green" />}
                </IconButton>
            </Grid>
            <Typography textAlign={"center"} m={"-2rem 0rem"} sx={{ opacity: .5 }}>ou</Typography>

            <Button
                startIcon={<BiLogoWhatsapp color="white" size={24} />}
                variant="contained"
                sx={{
                    background: "linear-gradient(90deg, #1D22E6 0%, #178BF1 100%)",
                    height: "4.8rem",
                    fontSize: "1.6rem",
                    fontWeight: 600,
                    animation: "pulse 2s infinite",
                    maxWidth: "80rem",
                    width: "100%",  // Garante que o botão ocupe toda a largura disponível até o valor máximo
                    margin: "3rem auto",  // Centraliza horizontalmente
                    display: "flex",
                }}
                onClick={shareWhatsApp}
            >
                Envie o link por WhatsApp
            </Button>

            <LineComponent />


            <Typography textAlign={"center"}>
                Sugestão:<br />

                Ao enviar o link para convidar seus clientes, envie também o vídeo GYROO.
            </Typography>

            <Button
                startIcon={<MdOndemandVideo color="primary" size={24} />}
                variant="outlined"
                sx={{
                    minHeight: "4.8rem",
                    fontSize: "1.6rem",
                    fontWeight: 600,
                    maxWidth: "80rem",
                    width: "100%",  // Garante que o botão ocupe toda a largura disponível até o valor máximo
                    margin: "3rem auto",  // Centraliza horizontalmente
                    display: "flex",
                }}
                onClick={downloadFiles}
            >
                Clique aqui para baixar o vídeo GYROO
            </Button>

            <Grid
                display={"flex"}
                direction={"column"}
                alignItems={"center"}
                justifyContent={"center"}
                flexDirection={"row"}
                width={"100%"}
                component={"a"}
                href="https://www.instagram.com/gyroo.oficial?igsh=MXdtczJlMmxkMDNvYw=="
                target="_blank"
                sx={{
                    textDecoration: "none",
                    m: "0 auto"
                }}

            >
                <img src={InstagramLogo} alt="instagram logo" style={{ width: "50px", height: "auto" }} />
                <Typography textAlign={"center"} fontSize={isMobile ? "1rem" : "1.5rem"} color="primary">Siga a GYROO no Instagram</Typography>
            </Grid>

            <LineComponent />

            <Typography fontSize={"2rem"} fontWeight={600} mb={"1rem"}>Clientes</Typography>
            {isMobile ?
                <Grid
                    mb={2}
                    container
                    display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    gap={"1rem"}
                    flexWrap={"nowrap"}
                    direction={"row"}
                >
                    <TextField
                        label="Buscar"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.keyCode === 13) {
                                getClients(search)
                            }
                        }}
                        variant="outlined"
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "100px",
                                height: "5.6rem",
                                fontSize: "1.6rem",
                                width: "100%",
                                maxWidth: "none",
                                minWidth: "none",
                                margin: 0,
                            },
                        }}
                    />

                    <IconButton
                        sx={{
                            border: "1px solid gray",
                            opacity: .7
                        }}
                        onClick={() => getClients(search)}
                    >
                        <CiSearch size={25} />
                    </IconButton>
                </Grid>
                :
                <Grid
                    mb={2}
                    container
                    justifyContent={"flex-end"}
                >
                    <TextField
                        label="Buscar"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onKeyDown={(e) => {
                            console.log(e.keyCode)
                            if (e.key === "Enter" || e.keyCode === 13) {
                                getClients(search)
                            }
                        }}
                        variant="outlined"
                        sx={{
                            width: "50rem"
                        }}
                    />
                </Grid>
            }

            {!isMobile && <TableComponent
                head={[
                    {
                        label: "ID",
                        placement: "left"
                    },
                    {
                        label: "Data de cadastro",
                        placement: "left"
                    },
                    {
                        label: "Cliente",
                        placement: "left"
                    },
                    {
                        label: "Empresa",
                        placement: "left"
                    },
                    {
                        label: "CNPJ",
                        placement: "left"
                    },
                    {
                        label: "WhatsApp",
                        placement: "left"
                    },
                    {
                        label: "UF",
                        placement: "left"
                    },
                    {
                        label: "Cidade",
                        placement: "left"
                    },
                ]}
                body={reorderProperties(clients).map((row) => {
                    const items: {
                        label: string,
                        placement?: TableCellProps["align"],
                        customized?: JSX.Element
                    }[] = []
                    for (const key of Object.keys(row)) {
                        if (key === "createdAt") {
                            items.push({
                                label: Format.dateWithTime(row[key])
                            })
                        } else if (key === "cnpj") {
                            items.push({
                                //@ts-ignore
                                label: Format.formatCNPJ(row[key])
                            })
                        } else {
                            items.push({
                                //@ts-ignore
                                label: row[key]?.toString()
                            })
                        }

                    }

                    return items
                })}
                loading={loading}
            />}

            {isMobile &&
                <Collapse in={clients?.length > 0}>
                    <Grid
                        display={"flex"}
                        direction={"column"}
                        gap={"1.5rem"}
                    >
                        {clients.map((c) => <MobileClient client={c} />)}
                    </Grid>
                </Collapse>
            }

            {(isMobile && clients?.length === 0) &&
                <Typography textAlign={"center"} sx={{ opacity: .5 }} mt={"2rem"}>Nenhum cliente encontrado...</Typography>
            }

            <ModalVideoPartner open={openModalVideo} onClose={() => {
                const videoReads = localStorage.getItem('video-partner-reads')
                if (videoReads) {
                    localStorage.setItem('video-partner-reads', (Number(videoReads) + 1).toString())
                } else {
                    localStorage.setItem('video-partner-reads', '1')
                }
                setOpenModalVideo(false)
            }} />

        </Box>
    )
}